import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { WelletContext } from '../../../context/wellet/welletContext';
import { getSpecialDatesByProduct } from '../../../services';
import { formatDateTranslation } from '../../../helpers/dates';
import { hasAllowedRoles } from '../../../helpers/roles';
import { Status } from '../../../uiComponents/common';
import { defaultQueryOptions } from '../../../utils/defaultQueryOptions';
import { useUser } from '../../../hooks';
import '../../../screens/fechasEspeciales/fechasEspeciales.css';

const getStatusProps = (status) => {
  switch (status) {
    case 'active':
      return { status: true };
    case 'upcoming':
      return { status: 'yellow' };
    case 'finished':
      return { status: false };
    default:
      return { status: false };
  }
};

const SpecialDatesLinkedSection = ({ productId, mode }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'forms.products.sectionSpecialDates' });
  const { t: tStatus } = useTranslation('translation', {
    keyPrefix: 'screens.fechasEspeciales.status',
  });
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const { roles } = useUser();
  const canViewSpecialDates = hasAllowedRoles(roles, [
    'superadministrator',
    'marketadmin',
    'admin',
    'productloader',
    'productpriceloader',
  ]);

  const { data, isError } = useQuery({
    queryKey: ['specialDatesByProduct', productId],
    queryFn: () => getSpecialDatesByProduct(welletContext, productId),
    ...defaultQueryOptions,
    enabled: !!productId,
  });

  const items = data?.data ?? [];

  if (isError || items.length === 0) return null;

  return (
    <div className='col-12 mt-3'>
      <div className='d-flex flex-column gap-2'>
        {items.map((item) => {
          const status = (item.status || '').toLowerCase();
          const statusProps = getStatusProps(status);
          const { date: fromDate } = formatDateTranslation(item.fromDate, language, 'small');
          const { date: toDate } = formatDateTranslation(item.toDate, language, 'small');

          return (
            <div key={item.id} className='fe-readonly-badge'>
              <div className='d-flex align-items-center justify-content-between'>
                <span className='fe-readonly-badge-text fw-600'>{item.name}</span>
                <Status status={statusProps.status} text={tStatus(status)} />
              </div>
              <div className='fe-readonly-badge-text'>
                <span className='sentences-capitalize'>{fromDate}</span>
                {' — '}
                <span className='sentences-capitalize'>{toDate}</span>
              </div>
              {canViewSpecialDates && (
                <Link
                  to={`/special-dates/${item.id}${mode === 'groups' ? '?tab=group' : '?tab=area'}`}
                  className='fe-readonly-badge-link'
                >
                  {t('viewLink')}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SpecialDatesLinkedSection;
